<template>
  <div>
    <fieldset>
      <div class="field">
        <label class="label">App Name</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder="Enter app name here"
            required
            v-model.trim="appName"
            @input="$v.appName.$touch()"
            :class="{ 'is-danger': $v.appName.$invalid && $v.appName.$dirty }"
          />
          <p class="help is-danger" v-if="$v.appName.$invalid && $v.appName.$dirty">The app name is required</p>
        </div>
      </div>
      <n-button-group>
        <n-button variant="primary" @click="save()" :disabled="$v.$invalid" :loading="actionInProgress"
          >Submit</n-button
        >
        <n-button @click="cancel()" variant="primary--outline">Cancel</n-button>
      </n-button-group>
    </fieldset>
  </div>
</template>

<script lang="ts" setup>
import { required } from '@vuelidate/validators';
import { appsApi } from '@/features/apps/shared/services/apps';
import { CreatePrivateAppViewModel } from '@/features/apps/shared/models';
import Toast from '@/shared/services/toast';
import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import { useStore } from 'vuex';
import { computed, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import useVuelidate from '@vuelidate/core';

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const handleSeriousError = (error: string) => store.dispatch(HANDLE_SERIOUS_ERROR, error);

const appName = ref('');
const actionInProgress = ref(false);

const validations = {
  appName: { required },
};

const $v = useVuelidate(validations, { appName });

const router = useRouter();

onBeforeMount(() => {
  if (!currentWorkspace.value) {
    handleSeriousError('No workspace selected');
  }
});

function save() {
  if (actionInProgress.value) {
    return;
  }

  actionInProgress.value = true;

  const request = {
    appName: appName.value,
  } as CreatePrivateAppViewModel;

  appsApi
    .createPrivateApp(currentWorkspace.value.id, request)
    .then((result) => {
      router.push({ name: 'private-apps-edit', params: { id: result.app.id } });
    })
    .catch((err) => Toast.showError(err.message))
    .finally(() => (actionInProgress.value = false));
}

function cancel() {
  router.push({ name: 'private-apps-list' });
}
</script>
